import axios from 'axios'
import config from '../config/app'

const appAPI = {
  getPaymentConfigs () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/app/payment-configs').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getVideos () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/app/videos').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getGoals () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/app/goals').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getImpactCategories () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/app/impact-categories').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getCategories () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/app/categories').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getContactNotifications () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/app/contact-notifications').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getTotalStat () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/app/total-stat').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getCompanyPlans () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/app/company-plans').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getOrgSizes () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/app/org-sizes').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getPremiumPackages () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/app/premium-packages').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getPackages () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/app/packages').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getPackagesList () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/app/packageslist').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getIndustries () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/app/industries').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getCountries (global = true) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/app/countries', { params: { global: global } }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getmemberCountries () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/app/member-countries').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getBeneficiaries () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/app/beneficiaries').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getRegions () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/app/regions').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getStates (countryId) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/app/states/' + countryId).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getMultipleCountryStates (countryId) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/app/statesforMulticountry/' + countryId).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getAllStates () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/app/all-states').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getRate () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/app/rate').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getTypes () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/app/types').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getPayments () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/app/payments').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getPaymentTypes () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/app/payment-types').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getDataUri (url) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/app/data-uri', {url: url}).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getProjectCountries () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/app/project-countries').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getTaxProjectCountries () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/app/tax-project-countries').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getCurrentPackage (packageName) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/app/current-package/package?package=' + packageName).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getProjectRegions () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/app/project-regions').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getContributPartners () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/app/contribute-partners').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  }
}

export default appAPI



// WEBPACK FOOTER //
// ./src/api/app.js